angular.module('shared').directive('countBadge', function() {
  return {
    restrict: 'E',
    scope: {
      count: '='
    },
    template: `<span class="nav-badge nav-badge--primary" ng-if="count">{{count > 999 ? '999+' : count}}</span>`
  };
});
